import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/utils.js';
/**
 * DefinitionList — stacked key/value rows for metadata blocks. Compose rows
 * as children: `<DefinitionList><DefinitionRow label="Campaign" value="CMP-1024" muted /></DefinitionList>`.
 * `muted` lightens the value to ink-3 — use it for ID values.
 */
export function DefinitionList({ children, className, ...rest }) {
    return (_jsx("dl", { className: cn('m-0 flex flex-col', className), ...rest, children: children }));
}
export function DefinitionRow({ label, value, muted = false, children, className, ...rest }) {
    return (_jsxs("div", { className: cn('flex items-center justify-between gap-4 border-b-[0.5px] border-line py-2.5 last:border-b-0', className), ...rest, children: [_jsx("dt", { className: "m-0 text-[13px] text-ink-3", children: label }), _jsx("dd", { className: cn('m-0 text-right font-mono text-sm font-medium leading-[1.4] tracking-[-0.005em] tabular-nums text-ink', muted && 'text-ink-3'), children: value != null ? value : children })] }));
}
//# sourceMappingURL=definition-list.js.map